import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { DefaultOptions } from '@apollo/client/core/ApolloClient';
import { getMobileAppData, getToken, isAuthenticated } from '@/helpers/utils';

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'x-source': 'mobile',
      'x-platform': 'browser',
      'x-station-app-version': getMobileAppData()?.version,
      'x-build': getMobileAppData()?.build,
      authorization: isAuthenticated() ? `Bearer ${getToken()}` : '',
    },
  };
});

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API,
});

// Cache is causing the sorting of the result object keys
const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
  mutate: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      itemsGroupedByService: {
        keyFields: ['serviceShortCode', ['items', ['itemID']]],
      },
    },
  }),
  defaultOptions,
  devtools: {
    enabled: import.meta.env.DEV,
  },
});

export default client;
